import gql from 'graphql-tag';

export const MY_RESILIENCE_PULSE_CHECK = gql`
  query myResiliencePulseCheck {
    myResiliencePulseCheck
  }
`;
